var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "stepForm", attrs: { model: _vm.formData, rules: _vm.rules } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { staticClass: "form-step-title", attrs: { span: 24 } },
            [
              _c("div", { staticClass: "steptitle" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.stepTitle) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.formData["sameAsApplicant"] !== undefined
                ? _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.formData["sameAsApplicant"],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "sameAsApplicant", $$v)
                        },
                        expression: "formData['sameAsApplicant']",
                      },
                    },
                    [
                      _vm._v(
                        "Same\n                as applicant details\n            "
                      ),
                    ]
                  )
                : _c("div", [_vm._v(" ")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.value, function (val, field, i) {
            return _c(
              "el-col",
              { key: "validation" + i, attrs: { sm: 24, md: 12 } },
              [
                field == "applying_as"
                  ? _c("el-form-item", { attrs: { prop: field } }, [
                      _c("label", { staticClass: "el-form--label-top" }, [
                        _vm._v(_vm._s(_vm.__("fieldnames." + field)) + "* "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "designer" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("Designer")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "manufacturer" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("Manufacturer")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "pr_agency" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("PR Agency")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "other" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("Other")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : field == "sameAsApplicant"
                  ? _c("div")
                  : field == "newsletter"
                  ? _c("el-form-item", { attrs: { prop: field } }, [
                      _c("label", { staticClass: "el-form--label-top" }, [
                        _vm._v(_vm._s(_vm.__("fieldnames." + field)) + "* "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("Yes")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 0 },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [_vm._v("No")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : field == "country"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.countryOptions,
                            fieldType: "select",
                            required: _vm.rules[field][0].required,
                            disabled: _vm.isSame,
                            formName: _vm.formName,
                            formStep: _vm.step,
                          },
                          on: {
                            change: function ($event) {
                              _vm.formData.state_region = ""
                            },
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "state_region"
                  ? [
                      _vm.currentStateOptions != {} &&
                      _vm.currentStateOptions.length != 0
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: field } },
                            [
                              _c("InputWh", {
                                attrs: {
                                  placeholder: field,
                                  options: _vm.currentStateOptions,
                                  fieldType: "select",
                                  required: _vm.rules[field][0].required,
                                  disabled: _vm.isSame,
                                  formName: _vm.formName,
                                  formStep: _vm.step,
                                },
                                model: {
                                  value: _vm.formData[field],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, field, $$v)
                                  },
                                  expression: "formData[field]",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "emptyfield" }, [
                            _vm._v(" "),
                          ]),
                    ]
                  : field == "category"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.categoryOptions,
                            fieldType: "select",
                            required: _vm.rules[field][0].required,
                            formName: _vm.formName,
                            formStep: _vm.step,
                          },
                          on: {
                            change: function ($event) {
                              _vm.formData.subcategory = ""
                            },
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "subcategory"
                  ? [
                      _c(
                        "el-form-item",
                        { attrs: { prop: field } },
                        [
                          _c("InputWh", {
                            attrs: {
                              placeholder: field,
                              options:
                                _vm.subCategoryOptions[_vm.formData.category],
                              fieldType: "select",
                              formName: _vm.formName,
                              formStep: _vm.step,
                              required: _vm.rules[field][0].required,
                            },
                            model: {
                              value: _vm.formData[field],
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, field, $$v)
                              },
                              expression: "formData[field]",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : field == "year_of_production"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.yearOptions,
                            fieldType: "select",
                            required: _vm.rules[field][0].required,
                            formName: _vm.formName,
                            formStep: _vm.step,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "images"
                  ? [
                      _c(
                        "el-form-item",
                        { attrs: { prop: field } },
                        [
                          _c("div", { staticClass: "field-heading" }, [
                            _vm._v("Image Upload *"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-pretext" }, [
                            _vm._v(
                              "\n                        FILE TYPE: JPG, PNG. ASPECT RATIO: W:1920px H:1080px. 300dpi/image, max 6MB per file. The\n                        file names should use explicitly Latin characters.\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-upload",
                            {
                              ref: "uploader",
                              refInFor: true,
                              attrs: {
                                action:
                                  "https://jsonplaceholder.typicode.com/posts/",
                                multiple: true,
                                drag: true,
                                "on-change": _vm.handleChange,
                                "on-remove": _vm.handleRemove,
                                "file-list": _vm.formData.images,
                                "auto-upload": false,
                                "list-type": "picture",
                              },
                            },
                            [
                              _c("div", { staticClass: "el-upload__text" }, [
                                _vm._v(
                                  "\n                            Drop files or click here to upload "
                                ),
                                _c("em", [_vm._v("up to 6 images")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "upload-icon" }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-aftertext" }, [
                            _vm._v(
                              "\n                        Notice: For more images or 3d renderings and plans please forward directly to us using\n                        either through wetransfer or dropbox along with a fully completed postal application at\n                        contact@globaldesignnews.com\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "el-form-item__error" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.filesError) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : field == "project_description"
                  ? [
                      _c(
                        "div",
                        { staticClass: "projectdesc" },
                        [
                          _c("div", { staticClass: "field-heading" }, [
                            _vm._v("Project Description *"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: field } },
                            [
                              _c("InputWh", {
                                attrs: {
                                  placeholder: field,
                                  fieldType: "textarea",
                                  required: _vm.rules[field][0].required,
                                  formName: _vm.formName,
                                  formStep: _vm.step,
                                },
                                model: {
                                  value: _vm.formData[field],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, field, $$v)
                                  },
                                  expression: "formData[field]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            disabled: field != "vat_id" ? _vm.isSame : false,
                            formName: _vm.formName,
                            formStep: _vm.step,
                            required: _vm.rules[field][0].required,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              2
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-buttons" },
        [
          _vm.step > 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    size: "medium",
                    icon: "el-icon-arrow-left",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("prevStep")
                    },
                  },
                },
                [_vm._v("\n            Back\n        ")]
              )
            : _c("div", [_vm._v(" ")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.handleNextStep()
                },
              },
            },
            [_vm._v("Next")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }